// Frequently Asked Questions for the Prescription Drives landing page + help center.
// Replace/extend these with the final questions and answers.
// Optional `audience` field can be 'customer' | 'pharmacy' | 'rider' | 'all' (defaults to 'all').

const faqs = [
  {
    question: 'What is Prescription Drives?',
    answer:
      'Prescription Drives (PD) is a pharmacy delivery platform that connects customers, pharmacies, and delivery riders so medicines can be ordered online and delivered to your door.',
    audience: 'all'
  },
  {
    question: 'How do I place an order?',
    answer:
      'Sign up as a customer, find a nearby pharmacy, chat to confirm your items, choose or add a delivery address, then pay securely. Your order is delivered by an assigned rider.',
    audience: 'customer'
  },
  {
    question: 'How do pharmacies get paid?',
    answer:
      'When a customer pays, Paystack automatically settles the pharmacy’s share to their bank account. A small platform commission is retained by Prescription Drives.',
    audience: 'pharmacy'
  },
  {
    question: 'How can I contact support?',
    answer:
      'You can reach our helpdesk anytime by phone or WhatsApp chat using the buttons in the Help section.',
    audience: 'all'
  }
];

export default faqs;
